<template>
  <div class="login-wrapper min-h-screen w-full flex flex-col justify-between" id="page-login">
    
    <!-- 1. Header Institucional ENA (Formal, con logos nítidos y enlace a ena.com.pa) -->
    <header class="ena-portal-header w-full flex items-center justify-between px-6 sm:px-16 py-3.5 z-10 flex-shrink-0">
      <div class="flex items-center gap-4">
        <img
          src="@/assets/images/elements/logo_ena.svg"
          class="h-8 sm:h-9 w-auto logo-white"
          alt="ENA"
        />
        <span class="header-divider">|</span>
        <img
          src="@/assets/images/elements/logo_panapass.svg"
          class="h-6 sm:h-7 w-auto logo-white"
          alt="Panapass"
        />
      </div>

      <a
        href="https://ena.com.pa/"
        target="_blank"
        rel="noopener noreferrer"
        class="ena-header-btn-inicio shadow-md hover:shadow-lg"
      >
        INICIO
      </a>
    </header>

    <!-- 2. Contenido Central: CARD Unificado con Fondo Oficial 20261025_fondo.webp -->
    <main class="ena-login-body flex-1 w-full flex items-center justify-center py-6 px-4">
      <div class="login-card-container">
        
        <!-- Cabecera del Card: Tag LOGIN + Tag de Acceso + Título Bienvenida -->
        <div class="card-header-block mb-5">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <span class="card-login-tag">
                <span class="tag-dot"></span>
                LOGIN
              </span>
              <div class="info-pill" title="Portal corporativo para gestión de cobranzas de ENA">
                <feather-icon icon="InfoIcon" svgClasses="h-3 w-3" />
              </div>
            </div>
            <span class="portal-badge">PORTAL COBRANZAS</span>
          </div>

          <h1 class="card-title text-2xl sm:text-3xl font-extrabold text-gray-900 leading-tight">
            Bienvenid@ <span class="title-ena">a ENA</span>
          </h1>
          <p class="card-subtitle text-gray-500 text-xs sm:text-sm mt-1 font-medium">
            Sistema Integrado de Gestión de Cobranzas
          </p>
        </div>

        <!-- Formulario de Autenticación -->
        <formulate-form name="loginform" @submit="loginHandler" class="w-full flex flex-col">
          
          <div class="form-group">
            <label class="form-label">CORREO ELECTRÓNICO</label>
            <div class="input-with-icon">
              <span class="input-icon">
                <feather-icon icon="MailIcon" svgClasses="h-4 w-4" />
              </span>
              <formulate-input
                type="text"
                placeholder="USUARIO@ENA.COM.PA"
                input-class="custom-form-input"
                errors-class="form-error-text"
                name="correo"
                validation="required|email"
                v-model="user.email"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">CONTRASEÑA</label>
            <div class="input-with-icon">
              <span class="input-icon">
                <feather-icon icon="LockIcon" svgClasses="h-4 w-4" />
              </span>
              <formulate-input
                autocomplete="off"
                type="password"
                placeholder="••••••••••••"
                input-class="custom-form-input"
                errors-class="form-error-text"
                name="contraseña"
                validation="required"
                v-model="user.password"
              />
            </div>
          </div>

          <!-- Botón de Ingreso Azul Institucional ENA -->
          <button
            type="button"
            id="button-with-loading"
            class="login-btn"
            @click="login"
          >
            <span>Ingresar al Portal</span>
            <feather-icon icon="ArrowRightIcon" svgClasses="h-4 w-4 ml-1.5" />
          </button>
        </formulate-form>

        <!-- Pie sutil del Card -->
        <div class="card-bottom-row flex items-center justify-between text-xs text-gray-400">
          <span>Corredores Norte, Sur y Este</span>
          <span class="status-live">
            <span class="pulse-cyan"></span>
            En Línea 24/7
          </span>
        </div>

      </div>
    </main>

    <!-- 4. Footer Institucional ENA (Logo grande y notorio + Conexión Segura) -->
    <footer class="ena-portal-footer w-full py-4 px-6 sm:px-16 flex flex-col sm:flex-row items-center justify-between gap-3 flex-shrink-0">
      <div class="flex items-center">
        <img
          src="@/assets/images/elements/logo_ena.svg"
          class="h-10 sm:h-11 w-auto logo-white"
          alt="Empresa Nacional de Autopistas S.A."
        />
      </div>

      <div class="sm:ml-auto flex items-center">
        <div class="secure-badge">
          <feather-icon icon="ShieldIcon" svgClasses="h-3.5 w-3.5" />
          <span>Conexión Segura</span>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        user: {
          email: "",
          password: "",
          remember_me: false,
        },
        popupActive: false,
        recaptchaWidgetId: null,
        input1: null,
        input2: null,
        input3: null,
        input4: null,
        input5: null,
        input6: null,
        validacionFallida: false,
        colorLoading: "#ffffff",
        backgroundLoading: "#0d6efd",
      };
    },
    computed: {
      theme() {
        return this.$store.state.theme;
      },
      code() {
        return this.$store.state.auth.code || false;
      },
    },
    methods: {
      async login() {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: "#button-with-loading",
          scale: 0.45,
        });
        try {
          await this.$formulate.submit("loginform");
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        } catch (error) {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        }
      },
      async loginHandler() {
        await this.$store.dispatch("auth/login", this.user);
      },
      close() {
        this.popupActive = false;
      },
    },
  };
</script>

<style lang="scss">
  /* Paleta Institucional ENA (ena.com.pa) */
  :root {
    --ena-primary: #0d6efd;
    --ena-primary-hover: #0b5ed7;
    --ena-primary-dark: #0a58ca;
    --ena-corporate-blue: #1c3671;
    --ena-badge-blue: #162b5b;
    --ena-cyan: #0dcaf0;
    --ena-orange: #f58220;
    --ena-orange-hover: #e07110;
    --ena-danger: #dc3545;
    --ena-border: #dee2e6;
    --ena-bg-soft: #f8fafc;
    --ena-text-dark: #111827;
    --ena-text-muted: #64748b;
  }

  .login-wrapper {
    background: #fbfcfe;
    overflow-x: hidden;
  }

  /* 1. Header Institucional */
  .ena-portal-header {
    background-color: var(--ena-corporate-blue);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    min-height: 64px;
  }

  .header-divider {
    color: rgba(255, 255, 255, 0.4);
    font-weight: 300;
    font-size: 1.2rem;
  }

  .logo-white {
    filter: brightness(0) invert(1);
  }

  .ena-header-btn-inicio {
    background: var(--ena-orange);
    color: #ffffff !important;
    font-weight: 700;
    border-radius: 9999px;
    padding: 0.4rem 1.6rem;
    font-size: 0.85rem;
    letter-spacing: 0.05em;
    display: inline-block;
    text-decoration: none;
    transition: all 0.2s ease;
  }

  .ena-header-btn-inicio:hover {
    background: var(--ena-orange-hover);
    transform: translateY(-1px);
  }

  /* 2. Contenido Central con imagen de fondo 20261025_fondo.webp */
  .ena-login-body {
    position: relative;
    background-image: url('~@/assets/images/elements/20261025_fondo.webp');
    background-size: cover;
    background-position: center 38%;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .ena-login-body::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 50% 45%, rgba(17, 35, 76, 0.48) 0%, rgba(12, 28, 64, 0.78) 100%);
    backdrop-filter: blur(1.5px);
    pointer-events: none;
  }

  .login-card-container {
    width: 100%;
    max-width: 440px;
    background-color: #ffffff;
    border-radius: 1.25rem;
    padding: 2.25rem 2.25rem 1.6rem 2.25rem;
    box-shadow: 0 20px 45px rgba(12, 28, 64, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(226, 232, 240, 0.9);
    position: relative;
    z-index: 10;
    box-sizing: border-box;
  }

  .login-card-container,
  .login-card-container * {
    box-sizing: border-box;
  }

  @media (max-width: 640px) {
    .login-card-container {
      padding: 1.75rem 1.25rem 1.25rem 1.25rem;
      max-width: 95%;
    }
  }

  .card-login-tag {
    color: #1e293b;
    font-size: 0.74rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
  }

  .tag-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: var(--ena-primary);
    margin-right: 0.4rem;
  }

  .portal-badge {
    background: rgba(13, 110, 253, 0.08);
    border: 1px solid rgba(13, 110, 253, 0.2);
    border-radius: 9999px;
    color: var(--ena-primary);
    font-size: 0.68rem;
    font-weight: 700;
    padding: 0.16rem 0.6rem;
    letter-spacing: 0.04em;
  }

  .info-pill {
    align-items: center;
    background: rgba(13, 110, 253, 0.08);
    border: 1px solid rgba(13, 110, 253, 0.22);
    border-radius: 9999px;
    color: var(--ena-primary);
    display: inline-flex;
    font-size: 0.7rem;
    height: 18px;
    width: 18px;
    justify-content: center;
    cursor: help;
    transition: all 0.2s ease;
  }

  .info-pill:hover {
    background: var(--ena-primary);
    color: #ffffff;
  }

  .card-title {
    color: var(--ena-text-dark);
    letter-spacing: -0.02em;
  }

  .title-ena {
    color: var(--ena-primary);
  }

  /* Campos de Formulario */
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.2rem;
    width: 100%;
  }

  .form-label {
    font-size: 0.73rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 0.45rem;
    display: block;
  }

  .input-with-icon {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .input-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 5;
    pointer-events: none;
  }

  .input-with-icon .formulate-input {
    width: 100%;
    margin-bottom: 0;
  }

  .custom-form-input {
    width: 100% !important;
    height: 46px !important;
    padding-left: 2.75rem !important;
    padding-right: 1rem !important;
    background-color: var(--ena-bg-soft) !important;
    border: 1px solid var(--ena-border) !important;
    border-radius: 0.75rem !important;
    color: var(--ena-text-dark) !important;
    font-size: 0.92rem !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
    box-shadow: none !important;
  }

  .custom-form-input:focus {
    background-color: #ffffff !important;
    border-color: var(--ena-primary) !important;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.16) !important;
    outline: none !important;
  }

  .custom-form-input::placeholder {
    color: #94a3b8;
    font-size: 0.86rem;
  }

  .form-error-text {
    color: var(--ena-danger) !important;
    font-size: 0.74rem;
    font-weight: 600;
    margin-top: 0.3rem;
  }

  /* Botón de Ingreso */
  .login-btn {
    appearance: none;
    background: linear-gradient(180deg, var(--ena-primary) 0%, var(--ena-primary-hover) 100%);
    border: 1px solid var(--ena-primary-dark);
    border-radius: 0.75rem;
    box-shadow: 0 10px 22px rgba(13, 110, 253, 0.28);
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.94rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    height: 46px;
    width: 100%;
    position: relative;
    margin-top: 0.35rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .login-btn:hover {
    background: linear-gradient(180deg, var(--ena-primary-hover) 0%, var(--ena-primary-dark) 100%);
    box-shadow: 0 12px 24px rgba(13, 110, 253, 0.35);
    transform: translateY(-1px);
  }

  .login-btn:active {
    transform: translateY(0);
  }

  .card-bottom-row {
    margin-top: 1.25rem;
    padding-top: 0.85rem;
    border-top: 1px solid #f1f5f9;
  }

  .status-live {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.72rem;
    font-weight: 600;
    color: #059669;
  }

  .pulse-cyan {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--ena-cyan);
    box-shadow: 0 0 6px var(--ena-cyan);
  }

  /* 4. Footer Institucional */
  .ena-portal-footer {
    background-color: var(--ena-corporate-blue);
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    min-height: 68px;
  }

  .secure-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.22);
    color: #ffffff;
    font-size: 0.74rem;
    font-weight: 600;
    padding: 0.3rem 0.85rem;
    border-radius: 9999px;
  }

  @media (max-width: 640px) {
    .ena-portal-header {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .ena-portal-footer {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
</style>
